import React, {useState, useRef, useEffect} from 'react';
import {RegexFields} from '../../../../constants/utils/regexFields';
import {DateWithModal} from '../../../../_common/dateWithModal';
import countryTranslation from 'i18n-iso-countries';
import french from 'i18n-iso-countries/langs/fr.json';
import { DepartamentsList } from '../../../../_common/personal/departamentsList';

export const CivilForm = ({personalData, setPersonalData, formReference}) => {
    countryTranslation.registerLocale(french);
	const initValue = parseInt(personalData.gender) || personalData.gender === "Male" ? 2 : 1;
	const [personalDataGender, setPersonalDataGender] = useState(initValue);

	useEffect(() => {
		let value = 1;
		if(personalData.gender === "Male"){
			value = 2;
		}
		if(typeof personalData.gender == 'number'){
			value = personalData.gender;
		}
		setPersonalDataGender(value);
	}, [personalData.gender])

	//let personalDataGender = ;
	const gender = { male: 2, female: 1 };

	return (
				<section className="block">
					<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-0">ETAT CIVIL</h4>
					<form className="py-sm" noValidate ref={formReference} id="CivilForm">
						<div className="form-inline mb-3">
							<div className="custom-control custom-radio custom-control-inline mr-6">
								<input required type="radio" id="Madame" name="SexMadameMonsieur" className="custom-control-input" checked={personalDataGender === gender.female} onChange={(e) => {
									setPersonalData({ ...personalData, gender: gender.female });
								}} />
								<label className="custom-control-label" htmlFor="Madame">Madame</label>
							</div>
							<div className="custom-control custom-radio custom-control-inline">
								<input type="radio" id="Monsieur" name="SexMadameMonsieur" className="custom-control-input" checked={personalDataGender === gender.male} onChange={(e) => {
									setPersonalData({ ...personalData, gender: gender.male });
								}} />
								<label className="custom-control-label" htmlFor="Monsieur">Monsieur</label>
							</div>
						</div>
						<div className="form-row">
							<div className="form-group col col-xl-4">
								<label className="h6 font-weight-bolder my-auto" htmlFor="Prenom">Prénom *</label>
								<input required type="text" className="form-control" id="Prenom" defaultValue={personalData.firstName} onChange={(e) => {
									e.preventDefault();
									setPersonalData({ ...personalData, firstName: e.target.value });
								}} pattern={RegexFields.nameWithoutNumbers} />
							</div>
							<div className="form-group col col-xl-4">
								<label className="h6 font-weight-bolder my-auto" htmlFor="Nom">Nom *</label>
								<input required type="text" className="form-control" id="Nom" defaultValue={personalData.lastName} onChange={(e) => {
									e.preventDefault();
									setPersonalData({ ...personalData, lastName: e.target.value });
								}} pattern={RegexFields.nameWithoutNumbers} />
							</div>
						</div>
						<div className="form-row">
							<div className="form-group col-12 col-sm col-xl">
								<label className="h6 font-weight-bolder my-auto" htmlFor="naissance">Date de naissance *</label>
								<DateWithModal isRequired={true} selectedDate={personalData.birthDate} setSelectedDate={(d) => setPersonalData({ ...personalData, birthDate: d })} />
							</div>
							<div className="form-group col-12 col-sm col-xl">
								<label className="h6 font-weight-bolder my-auto" htmlFor="Commune">Commune de naissance</label>
								<input required={false} type="text" className="form-control" id="Commune" defaultValue={personalData.birthPlace} onChange={
									(e) => {
										e.preventDefault();
										setPersonalData({ ...personalData, birthPlace: e.target.value });
									}
								} pattern={RegexFields.nameWithoutNumbers} />
							</div>
							<div className="d-none"></div>
							<div className="form-group col-12 col-sm">
								{
									personalData.country === 'FR' || personalData.country === 'GF' || personalData.country === 'PF' || personalData.country === 'TF' || personalData.country === null ?
										<label className="h6 font-weight-bolder my-auto" htmlFor="departmentNumber">Nº de département *</label>
										:
										<label className="h6 font-weight-bolder my-auto" htmlFor="departmentNumber">Nº de département</label>
								}
								<select required={personalData.country === 'FR' || personalData.country === 'GF' || personalData.country === 'PF' || personalData.country === 'TF' || personalData.country === null ? true : false} disabled={personalData.country !== 'FR' && personalData.country !== null} className="custom-select" id="departmentNumber" value={personalData.departmentNumber} onChange={(event) => {
									setPersonalData({ ...personalData, departmentNumber: event.target.value });
								}}>
									<option value="">Choisir un département</option>
									{
										DepartamentsList.map((country, index) => {
											return (
												<option key={index} value={country}>{country}</option>
											);
										})
									}
								</select>
							</div>
							<div className="form-group col-12 col-sm">
								<label className="h6 font-weight-bolder my-auto" htmlFor="naturalite">Pays *</label>
								<select className="custom-select" id="naturalite" value={personalData.country} onChange={(event) => {
									setPersonalData({ ...personalData, country: event.target.value });
								}}>
									{
										Object.values(countryTranslation.getNames("fr", { select: "official" })).sort().map((countryName) => {
											const countryCode = countryTranslation.getAlpha2Code(countryName, "fr");
											return (
												<option key={countryCode} value={countryCode}>{countryName}</option>
											);
										})
									}
								</select>
							</div>
						</div>
					</form>
				</section>
	)
}